export default __webpack_public_path__ + "static/project-slide-3-2016-765-b735d4311855fb38667a47eeb38358a0.webp";